import { accountIdFormat, productIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const ProductSearchResultSchema_ = z.object({
  id: productIdFormat.schema,
  title: z.string(),
  sku: z.string().nullable(),
  imageUrl: z.string().nullable(),
});
export const ProductSearchResultSchema: z.ZodType<ProductSearchResult> =
  ProductSearchResultSchema_;
export interface ProductSearchResult
  extends z.infer<typeof ProductSearchResultSchema_> {}

export const searchProducts = unaryRpc({
  name: "searchProducts" as const,
  input: z.object({
    accountId: accountIdFormat.schema,
    query: z.string(),
    limit: z.number().min(1).max(50).default(20),
  }),
  output: z.object({ products: z.array(ProductSearchResultSchema) }),
});
